module.exports = __webpack_public_path__ + "static/media/moreCoins.5cf9c2f6.png";